import { onMounted, ref } from 'vue';
import { useStore } from 'dashboard/composables/store';

const CENTERTEL_URL = 'https://ennychat.com.br';
const SESSION_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutos

/**
 * Composable que gerencia:
 * - SSO: bloqueia login nativo se Centertel online
 * - Sessão: timeout 10min de inatividade
 * - Sessão única: kick se outra sessão for iniciada
 */
export function useCentertelSession() {
  const store = useStore();
  const isBlocked = ref(false);
  const isKicked = ref(false);
  const kickReason = ref('');

  let sessionTimer = null;
  let sessionCheckInterval = null;

  // ── A. SSO: Bloquear login nativo ──
  // TEMPORARIAMENTE DESABILITADO para testes
  // Descomente o bloco abaixo para ativar o bloqueio SSO
  const checkSSOBlock = async () => {
    const path = window.location.pathname;
    const isLoginPage = ['/auth/sign_in', '/auth/login', '/app/login'].some(
      p => path.includes(p)
    );
    if (!isLoginPage) return;

    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      const r = await fetch('https://api.ennychat.com.br/api/health/', {
        signal: controller.signal,
      });
      clearTimeout(timeout);
      const data = await r.json();
      if (data?.status === 'ok') {
        isBlocked.value = true;
      }
    } catch {
      // Centertel offline → libera login nativo
    }
  };

  // ── B. Sessão: timeout inatividade ──
  const resetSessionTimer = () => {
    if (sessionTimer) clearTimeout(sessionTimer);
    sessionTimer = setTimeout(() => {
      store.dispatch('logout');
    }, SESSION_TIMEOUT_MS);
  };

  const setupSessionTimeout = () => {
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach(e => document.addEventListener(e, resetSessionTimer, { passive: true }));
    resetSessionTimer();
  };

  // ── B2. Sessão única ──
  const setupSessionCheck = () => {
    const urlParams = new URLSearchParams(window.location.search);
    let sessionId = urlParams.get('cwc_session_id') || localStorage.getItem('cwc_session_id');
    if (!sessionId) return;

    localStorage.setItem('cwc_session_id', sessionId);

    // Limpar da URL
    if (urlParams.has('cwc_session_id')) {
      urlParams.delete('cwc_session_id');
      const clean = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
      window.history.replaceState({}, '', clean);
    }

    const currentUser = store.getters.getCurrentUser;
    if (!currentUser?.id) return;

    sessionCheckInterval = setInterval(async () => {
      try {
        const r = await fetch(
          `${CENTERTEL_URL}/api/usuarios/chat/session-check?session_id=${sessionId}&user_id=${currentUser.id}`
        );
        const data = await r.json();
        if (data?.data?.valid === false) {
          localStorage.removeItem('cwc_session_id');
          isKicked.value = true;
          kickReason.value = data.data.reason || 'Outra sessão foi iniciada.';
          clearInterval(sessionCheckInterval);
          store.dispatch('logout');
        }
      } catch {
        // Ignore
      }
    }, 30000);
  };

  onMounted(() => {
    checkSSOBlock();
    const currentUser = store.getters.getCurrentUser;
    if (currentUser?.id) {
      setupSessionTimeout();
      setupSessionCheck();
    }
  });

  return {
    isBlocked,
    isKicked,
    kickReason,
    centertelUrl: CENTERTEL_URL,
  };
}
